import axios from 'axios';
const QUIZLER_URL = process.env.QUIZLER_URL || '/api/quizler';

export const fetchPoll = (pollId) => {
    return axios({
        method: 'GET',
        url: `${QUIZLER_URL}/poll/${pollId}`
    })
};

export const fetchVotes = (pollId) => {
    return axios({
        method: 'GET',
        url: `${QUIZLER_URL}/poll/votes/${pollId}`
    })
};

export const registerVote = (pollOptionId) => {
    return axios({
        method: 'POST',
        url: `${QUIZLER_URL}/poll/vote/${pollOptionId}`
    })
};

export const fetchResults = (pollId) => {
    return axios({
        method: 'GET',
        url: `${QUIZLER_URL}/poll/resource/${pollId}`
    })
};